import WeakMap from 'core-js/fn/weak-map';

export default class CounterWeakMap {

	constructor () {
		this._wm = new WeakMap();
	}

	/**
	 * Reset a weakmap
	 * @return {void}
	 */
	clear () {
		this._wm = new WeakMap();
	}

	/**
	 * Remove an item from a weakmap by key
	 * @param {obj} k - weakmap key.
	 * @return {bool} result of removing
	 */
	delete (k) {
		return this._wm.delete(k);
	}

	/**
	 * Get current value for a counter
	 * @param {obj} k - weakmap key.
	 * @return {int} counter value
	 */
	get (k) {
		return this._wm.get(k);
	}

	/**
	 * Checking if there is such key in weakmap.
	 * @param {obj} k - weakmap key.
	 * @return {bool} result of checking
	 */
	has (k) {
		return this._wm.has(k);
	}

	/**
	 * Add new key with a counter if there is no already such key.
	 * @param {obj} k - weakmap key.
	 * @return {bool} result of adding
	 */
	add (k) {
		if (this.has(k)) {
			return false;
		}
		this._wm.set(k, 0);

		return true;
	}

	/**
	 * Reset the counter for the key.
	 * @param {obj} k - weakmap key.
	 * @return {int} counter value
	 */
	reset (k) {
		this._wm.set(k, 0);
		return 0;
	}

	/**
	 * Increment the counter for the key.
	 * @param {obj} k - weakmap key.
	 * @return {int} incremented counter value
	 */
	increment (k) {
		const count = this._wm.get(k) + 1;
		this._wm.set(k, count);
		return count;
	}

	/**
	 * Decrement the counter for the key.
	 * @param {obj} k - weakmap key.
	 * @return {int} decremented counter value
	 */
	decrement (k) {
		let count = this._wm.get(k) - 1;
		if (count < 0) {
			count = 0;
		}
		this._wm.set(k, count);
		return count;
	}
}
